import React from 'react';
import Container from './Container';
import PeakLogo from '../ui/PeakLogo';
import { colors, font } from '../../lib/tokens';

const FOOTER_COLUMNS = [
  {
    heading: 'Company',
    links: [
      { label: 'Product', href: '/#product' },
      { label: 'Security', href: '/#security' },
      { label: 'News', href: '/#news' },
      { label: 'Team', href: '/#team' },
    ],
  },
  {
    heading: 'Media',
    links: [
      { label: 'Press kit', href: '/press' },
      { label: 'Brand manual', href: '/brand' },
      { label: 'Logo pack (ZIP)', href: '/press-kit/katlacode-press-kit.zip' },
    ],
  },
];

const columnHeading: React.CSSProperties = {
  fontFamily: font.mono,
  fontSize: 11,
  letterSpacing: 0.6,
  textTransform: 'uppercase',
  color: '#64748B',
  marginBottom: 16,
};

export default function Footer() {
  return (
    <footer style={{ background: colors.ink, color: '#94A3B8', padding: '64px 0 40px' }}>
      <Container>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 48,
            flexWrap: 'wrap',
          }}
        >
          <div style={{ maxWidth: 340 }}>
            <PeakLogo color="#FFF" accent="#93C5FD" size={28} />
            <p style={{ fontSize: 13, lineHeight: 1.6, marginTop: 16, color: '#94A3B8' }}>
              Clinical coding infrastructure, built inside hospitals.
            </p>
          </div>
          <div style={{ display: 'flex', gap: 64, flexWrap: 'wrap' }}>
            {FOOTER_COLUMNS.map((column) => (
              <div key={column.heading}>
                <div style={columnHeading}>{column.heading}</div>
                <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                  {column.links.map((link) => (
                    <li key={link.label} style={{ marginBottom: 10 }}>
                      <a href={link.href} className="kc-footer-link" style={{ fontSize: 14 }}>
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div>
              <div style={columnHeading}>Contact</div>
              <a
                href="mailto:info@katlacode.ai"
                className="kc-footer-link"
                style={{ fontSize: 15, fontWeight: 500, color: '#FFF' }}
              >
                info@katlacode.ai
              </a>
              <p style={{ fontSize: 13, marginTop: 10, color: '#94A3B8' }}>Reykjavík, Iceland</p>
            </div>
          </div>
        </div>
        <div
          style={{
            borderTop: '1px solid rgba(255,255,255,0.1)',
            marginTop: 48,
            paddingTop: 20,
            fontSize: 11,
            fontFamily: font.mono,
            letterSpacing: 0.6,
            textTransform: 'uppercase',
            color: '#94A3B8',
          }}
        >
          © {new Date().getFullYear()} Katlacode ehf · Reykjavík
        </div>
      </Container>
    </footer>
  );
}
